<template>
  <component :is="pageComponent" />
</template>

<script>
import PcTicket from "@/views/pc/ticket/index.vue";
import MTicket from "@/views/mobile/ticket/index.vue";
import { isMobile } from "@/utils/device";

export default {
  name: "TicketBridge",
  computed: {
    pageComponent() {
      return isMobile() ? MTicket : PcTicket;
    },
  },
};
</script>
